module.exports = __webpack_public_path__ + "static/media/OK.c2c35909.jpg";